export enum Role {
  Admin = 'ADMIN',
  OrgAdmin = 'ORG_ADMIN',
  Member = 'ORG_MEMBER',
  VendorAdmin = 'VENDOR_ADMIN',
  Cashier = 'VENDOR_CASHIER'
}
